import React from "react";

import WarehouseDashboard from "../components/dashboard/WarehouseDashboard";
import KpiCards from "../components/KpiCards";
import NewsBanner from "../components/NewsBanner";
import NewsCharts from "../components/NewsCharts";
import PostList from "../components/PostList";

import "../news-feed.css";

export default function NewsFeedPage() {
  const fontStyle = { fontFamily: "'Inter', sans-serif" };

  return (
    <div
      className="news-feed-scope !font-inter !min-h-screen !bg-slate-50/60 !p-3 sm:!p-4 md:!p-5 !text-sm"
      style={fontStyle}
    >
      {/* Inline style enforcing Inter with maximum specificity over any global SCSS */}
      <style>{`
        html body .news-feed-scope,
        html body .news-feed-scope *,
        html body .news-feed-scope *::before,
        html body .news-feed-scope *::after,
        html body .news-feed-scope div,
        html body .news-feed-scope span,
        html body .news-feed-scope p,
        html body .news-feed-scope h1,
        html body .news-feed-scope h2,
        html body .news-feed-scope h3,
        html body .news-feed-scope h4,
        html body .news-feed-scope h5,
        html body .news-feed-scope h6,
        html body .news-feed-scope button,
        html body .news-feed-scope input,
        html body .news-feed-scope select,
        html body .news-feed-scope option,
        html body .news-feed-scope textarea,
        html body .news-feed-scope label,
        html body .news-feed-scope a,
        html body .news-feed-scope table,
        html body .news-feed-scope thead,
        html body .news-feed-scope tbody,
        html body .news-feed-scope tfoot,
        html body .news-feed-scope tr,
        html body .news-feed-scope th,
        html body .news-feed-scope td,
        html body .news-feed-scope svg,
        html body .news-feed-scope svg text,
        html body .news-feed-scope svg tspan {
          font-family: 'Inter', sans-serif !important;
        }
      `}</style>

      <div
        className="!max-w-[1760px] !w-full !mx-auto !space-y-5"
        style={fontStyle}
      >
        {/* 1. Header Banner */}
        <NewsBanner />

        {/* 2. Thẻ KPI tổng hợp phiếu chờ duyệt */}
        <KpiCards />

        {/* 3. PHẦN THỐNG KÊ: Tồn kho, Mua hàng, Biểu đồ biến động & Định mức tồn kho */}
        <WarehouseDashboard />

        {/* 4. Biểu đồ 7 ngày xuất nhập kho */}
        <div className="!space-y-2" style={fontStyle}>
          <h5
            className="uppercase font-semibold tracking-wider text-slate-700 !text-sm sm:!text-base"
            style={fontStyle}
          >
            Biến động giá trị xuất nhập 7 ngày qua
          </h5>
          <NewsCharts />
        </div>

        {/* 5. Bảng tin & Thông báo điều hành */}
        <div className="!space-y-2" style={fontStyle}>
          <h5
            className="uppercase font-semibold tracking-wider text-slate-700 !text-sm sm:!text-base"
            style={fontStyle}
          >
            Bảng tin & Thông báo điều hành
          </h5>
          <div className="!w-full" style={fontStyle}>
            <PostList />
          </div>
        </div>
      </div>
    </div>
  );
}
